import { supabase } from './supabase';

export interface FeedbackRequest {
  type: 'bug' | 'feature';
  subject: string;
  description: string;
  consoleLogs?: string;
  userEmail: string;
  userName: string;
  userRole?: string;
  organizationId?: string;
  userAgent: string;
  currentUrl: string;
  timestamp: string;
}

export async function submitFeedback(
  request: FeedbackRequest
): Promise<{ success: boolean; error?: string }> {
  try {
    const { data, error } = await supabase.functions.invoke('submit-feedback', {
      body: request,
    });

    if (error) {
      console.error('Feedback submit error:', error);
      return {
        success: false,
        error: error.message || 'Failed to submit feedback',
      };
    }

    return data as { success: boolean; error?: string };
  } catch (err) {
    console.error('Feedback submit exception:', err);
    return {
      success: false,
      error: err instanceof Error ? err.message : 'Unknown error occurred',
    };
  }
}
